"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFormats = exports.UserLanguage = exports.UserRoles = void 0;
var UserRoles;
(function (UserRoles) {
    UserRoles["ADMIN"] = "admin";
    UserRoles["USER"] = "user";
    UserRoles["LEAD"] = "lead";
    // TODO: Remove unused roles
    UserRoles["PAD"] = "pad";
    UserRoles["INSTALLER"] = "installer";
    UserRoles["SUPPORT"] = "support";
    UserRoles["STOCK"] = "stock";
})(UserRoles = exports.UserRoles || (exports.UserRoles = {}));
var UserLanguage;
(function (UserLanguage) {
    UserLanguage["FR"] = "fr";
    UserLanguage["EN"] = "en";
    UserLanguage["AR"] = "ar";
    UserLanguage["DE"] = "de";
    UserLanguage["ES"] = "es";
    UserLanguage["IT"] = "it";
})(UserLanguage = exports.UserLanguage || (exports.UserLanguage = {}));
var DateFormats;
(function (DateFormats) {
    DateFormats["DD_MM_YYYY"] = "DD/MM/YYYY";
    DateFormats["MM_DD_YYYY"] = "MM/DD/YYYY";
    DateFormats["YYYY_MM_DD"] = "YYYY/MM/DD";
    DateFormats["UNIVERSAL"] = "YYYY-MM-DD";
})(DateFormats = exports.DateFormats || (exports.DateFormats = {}));
